import React, { Component } from "react";
import { connect } from "react-redux";
import Dashboard from "../Components/Dashboard";

import {
  viewTestDriveLength,
  viewContactUsLengths,
  viewOldCarLength,
  uploadupdatesImages,
  deleteContact,
} from "../action";
import { onLogout } from "../../Auth/Actions";
export class Controller extends Component {
  render() {
    return <Dashboard {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    client: store.client,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    viewOldCarLength: (token, user_id) => {
      dispatch(viewOldCarLength(token, user_id));
    },

    viewTestDriveLength: (token, user_id) => {
      dispatch(viewTestDriveLength(token, user_id));
    },
    viewContactUsLengths: (token, user_id) => {
      dispatch(viewContactUsLengths(token, user_id));
    },
    onLogout: () => {
      dispatch(onLogout());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
